import { Edit3, Trash2 } from 'lucide-react'
import { Button, StatePanel, StatusBadge } from '@/components/common'
import { itemIsActive } from './formatters'
import styles from './igaming.module.css'

export function DataList({ items, primary, meta, renderDetails, onEdit, onDelete, deletePending }) {
  if (!items.length) return <StatePanel state="empty" title="Nothing configured yet" compact />
  return (
    <div className={styles.ruleList}>
      {items.map((item) => (
        <article key={item.id} className={styles.ruleItem}>
          <div className={styles.ruleMain}>
            <div className={styles.ruleTitleRow}>
              <strong>{primary(item)}</strong>
              <StatusBadge type={itemIsActive(item) ? 'success' : 'default'} size="small">
                {itemIsActive(item) ? 'Active' : 'Inactive'}
              </StatusBadge>
            </div>
            <div className={styles.ruleMeta}>
              {meta(item).filter(Boolean).map((value) => <span key={value}>{value}</span>)}
            </div>
            {renderDetails ? renderDetails(item) : null}
          </div>
          {onEdit || onDelete ? (
            <div className={styles.ruleActions}>
              {onEdit ? (
                <Button variant="secondary" aria-label={`Edit ${primary(item)}`} onClick={() => onEdit(item)}>
                  <Edit3 size={15} />
                  Edit
                </Button>
              ) : null}
              {onDelete ? (
                <Button variant="danger" aria-label={`Delete ${primary(item)}`} disabled={deletePending} onClick={() => onDelete(item.id)}>
                  <Trash2 size={15} />
                  Delete
                </Button>
              ) : null}
            </div>
          ) : null}
        </article>
      ))}
    </div>
  )
}
